import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import Navbar from "../components/Navbar";
import { AppProps } from "../App";

const PageNotFound = (props: AppProps) => {

  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <>
      <Navbar {...props} />
      <main className="flex-1 flex flex-col items-center justify-center p-4">
        <h1 className="font-bold text-3xl text-center">{t('home.page-not-found')}</h1>
        <div onClick={() => navigate('/')} className="text-primary mt-4 underline cursor-pointer">{t('home.back')}</div>
      </main>
    </>
  )
}

export default PageNotFound;